import axios from 'axios';
import { config } from '../Configurator'
import { buildCaseAssessorPayload, convertDateForApi } from '../Utils'
import alertify from 'alertifyjs';

const endpoint = "UpdateCase";
const endpoint2 = "GetCaseAssessorByCaseJSON";
const endpoint3 = "UpdateCaseAssessorJSON";

export const executeMasterUpdateCase = (att, applicant_id, customer_reference) => {

    if(applicant_id===null) {
        alertify.confirm("Error", "Applicant ID can't be null", null, null);
        return false;
    }

    console.log('passed customer reference ==' + customer_reference);

    // #1 Update case data 
    axios.post(config().base_url + endpoint, updateCasePayload(att, applicant_id, customer_reference)).then(function(response){
        let value = '';
        if(response.data.d.UpdateResult.SuccessCode==0) {

            // #2 if update goes well, get case assessor 

            value = response.data.d.Value;

            axios.post(config().base_url + endpoint2, getCaseAssessorPayload(applicant_id)).then(function (response) {

                if(response.data.d.EnquiryResult.SuccessCode==0) {
                    // #3 if everything okay update case assessor 
                    axios.post(config().base_url + endpoint3, buildCaseAssessorPayload(att, applicant_id, response.data)).then(function (response) {
                        if(response.data.d.EnquiryResult.SuccessCode==0) {
                            if(att.form_id=='13') { // delay for sound to play 
                                setTimeout(function(){ window.location.href = "/case/" + applicant_id;  }, 2800);
                            } else {
                                window.location.href = "/case/" + applicant_id;
                            }
                        } else {
                            alertify.confirm('Error', response.data.d.EnquiryResult.Message, null, null);
                        }
                    }).catch(function (error){
                        alertify.confirm('Error', error.message, null, null);
                    });

                } else {
                    alertify.confirm('Error', response.data.d.EnquiryResult.Message, null, null);

                }
            }).catch(function (error){
                alertify.confirm('Error', error.message, null, null);
            });

            // window.location.href = "/thanks/" + response.data.d.Value;
        } else {
            alertify.confirm('Error', response.data.d.UpdateResult.Message, null, null);

        }
    }).catch(function (error){
        alertify.confirm('Error', error.message, null, null);
    });




}

const updateCasePayload = (att, applicant_id, customer_reference) => {
    let ret = {
        "UserInfo": {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password')
        },
        "CaseApp": {
            "ApplicantID": applicant_id,
            "CustomerReference": customer_reference,
            "AvoidUpdatingBlankData":true,
            "IsUpdateCaseCustomer":true,
            "MainApplicant": {
                "Title": att.Title,
                "Firstname": att.FirstName,
                "Surname": att.Surname,
                "DateOfBirth": convertDateForApi(""),
                "Telephone": att.Telephone,
                "WorkTelephone": att.WorkTelephone,
                "Mobile": att.Mobile,
                "EmailAddress": att.Email,
                "CurrentAddress": {
                    "HouseName": att.HouseName,
                    "HouseNumber": att.HouseNumber,
                    "Address1": att.Address1,
                    "Address2": att.Address2,
                    "Address3": att.Address3,
                    "Address4": att.Address4,
                    "PostCode": att.Postcode
                },
                "PreviousAddresses": {},
                "App2ID": 0
            },
            "MatterType": att.MatterType,
            "Provider": att.Provider,
            "ProviderDescription": att.ProviderDescription,
            "ProviderRef": att.ProviderRef,
            "ProviderCaseRef": att.ProviderCaseRef,
            "OldCaseRef": att.OldCaseRef,
            "CreditType": att.OldCaseRef,
            "NetClaim": att.NetClaim ?? 0,
            "Commission": att.Commission,
            "ClaimInterest": att.ClaimInterest,
            "CustomerInitialFee": att.CustomerInitialFee ?? 0,
            "CustomerCompletionFeePerc": att.CustomerCompletionFeePerc,
            "CustomerCompletionFee": att.CustomerCompletionFee ?? 0,
            "CaseStatus": att.CaseStatus,
            "StatusDate": convertDateForApi(""),
            "Source": att.Source,
            "SourceRef": att.SourceRef,
            "SourceAffiliate": att.SourceAffiliate,
            "DateCreated": convertDateForApi(""),
            //"UserCreated": null,
            "WorkflowStep": '',
            //"DaysOld": null,
            "CaseOwner": att.CaseOwner,
            "CustomerOwner": att.CustomerOwner,
            "BrokerCode": att.BrokerCode,
            "BrokerName": att.BrokerName,
            "BrokerReference": att.BrokerReference,
            "EquipmentDetails": [
                {
                    "ID": "",
                        "ModelName": "",
                        "ModelDescription": "",
                        "Manufacturer": "",
                        "ManufacturerYear": "",
                        "ListPrice": "",
                        "SalePrice": "",
                        "Vat": "",
                        "Condition": "",
                        "EquipmentCustomField": [
                            {
                                "CustomFieldNo": "1",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "2",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "3",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "4",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "5",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "6",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "7",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "8",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "9",
                                "CustomFieldValue": ""
                            },
                            {
                                "CustomFieldNo": "10",
                                "CustomFieldValue": ""
                            }
                    ],
                    "ForceDelete": null
                }
            ],
            "DynamicFieldDetail": [{
                "FieldNo": 1,
                "FieldValue": att.dynamicData1
            },
            {
                "FieldNo": 2,
                "FieldValue": att.dynamicData2
            },
            {
                "FieldNo": 3,
                "FieldValue": att.dynamicData3
            },
            {
                "FieldNo": 4,
                "FieldValue": att.dynamicData4
            },
            {
                "FieldNo": 5,
                "FieldValue": att.dynamicData5
            },
            {
                "FieldNo": 6,
                "FieldValue": att.dynamicData6
            },
            {
                "FieldNo": 7,
                "FieldValue": att.dynamicData7
            },
            {
                "FieldNo": 8,
                "FieldValue": att.dynamicData8
            },
            {
                "FieldNo": 9,
                "FieldValue": att.dynamicData9
            },
            {
                "FieldNo": 10,
                "FieldValue": att.dynamicData10
            },
            {
                "FieldNo": 11,
                "FieldValue": att.dynamicData11
            },
            {
                "FieldNo": 12,
                "FieldValue": att.dynamicData12
            }
            ],
            /*
            "SecurityAddress": [
                {
                    "Code": "",
                    "HouseName": '',
                    "HouseNumber": "",
                    "Address1": "",
                    "Address2": '',
                    "Address3": '',
                    "Address4": "",
                    "Postcode": "",
                    "CurrentValue": att.CurrentValue,
                    "SecuirtyType": att.secuirtyType,
                    "SecuirtyDetails": att.secuirtyDetails,
                    "SecuirtyCharge": null,
                    "SecuirtyChargeValue": att.SecuirtyChargeValue,
                    "SecuirtyChargeDate": null,
                    "SecuirtyEquityValue": att.SecuirtyEquityValue,
                    "SecuirtyLendingValue": att.SecuirtyLendingValue,
                    "SecuirtyPurchaseValue": 0,
                    "SecuirtyPurchaseDate": '',
                    "SecuirtyMortgageValue": 0,
                    "SecuirtyMarketValue": 0,
                    "SecurityTitleNumber": '',
                    "SecurityCustomField": [
                        {
                            "CustomFieldNo": "1",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "2",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "5",
                            "CustomFieldValue": ""
                        }
                    ]
                }
            ],
            */
            "CaseNotesList": {
                "CaseNotes": {
                    "NoteType": att.NoteType,
                    "ApplicantId": '',
                    "Notes": att.Notes,
                    "CreatedDate": convertDateForApi(''),
                    "CreatedBy": att.CreatedBy,
                    "CreatedByName": att.CreatedByName,
                    "Status": att.Status,
                }
            }
        }
    }


    ret.CaseApp.SecurityAddress = [];
    // handle securities 
    for(let i=0; i<100; i++) {
        if(typeof att['SecuirtyCode__' + i] !=='undefined') {
            console.log(att['SecuirtyCode__' + i]);

            ret.CaseApp.SecurityAddress.push(
                {
                    "Code": att['SecuirtyCode__' + i],
                    "HouseName": att['SecurityHouseName__' + i],
                    "HouseNumber": att['SecurityHouseNo__' + i],
                    "Address1": att['SecurityAddress1__' + i],
                    "Address2": att['SecurityAddress2__' + i],
                    "Address3": att['SecurityAddress3__' + i],
                    "Address4": att['SecurityAddress4__' + i],
                    "Postcode": att['SecurityPostcode__' + i],
                    "CurrentValue": att['CurrentValue__' + i],
                    "SecuirtyType": att['secuirtyType__' + i],
                    "SecuritySubType": att['SecuritySubType__' + i],
                    "SecuirtyDetails": att['secuirtyDetails__' + i],
                    "SecuirtyCharge": att['SecurityCharge__' + i],
                    "SecuirtyChargeValue": att['SecuirtyChargeValue__' + i],
                    "SecuirtyChargeDate": convertDateForApi(null),
                    "SecuirtyEquityValue": att['SecuirtyEquityValue__' + i],
                    "SecuirtyLendingValue": att['SecuirtyLendingValue__' + i],
                    "SecuirtyPurchaseValue": 0,
                    "SecuirtyPurchaseDate": convertDateForApi(''),
                    "SecuirtyMortgageValue": 0,
                    "SecuirtyMarketValue": Number(att['security_multiplier__' + i]),
                    "SecurityTitleNumber": att['SecurityTitle__' + i],
                    "SecurityCustomField": [
                        {
                            "CustomFieldNo": "1",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "2",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "3",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "4",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "5",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "6",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "7",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "8",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "9",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "10",
                            "CustomFieldValue": ""
                        }
                    ]
                }
             );
        }
    }
    return ret;
}

const getCaseAssessorPayload = (applicant_id) => {
    return {
        "UserInfo": {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password')
                  },
                  "jobCode": applicant_id
    }
}

export default {
    executeMasterUpdateCase
};
